/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { createDialogRoute, getDialogInitData } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import {
  HousePlanEstimateDetailsBusinessService,
  HpeOrderDetailsDialogConfig,
} from '../../../resources/house-plan-estimate-details-business.service';
import { HpeCcOrderDetails } from '../../../resources/hpe-details.model';
import { HpeOrderDetailsGridDefinition } from './hpe-order-details-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-hpe-order-details-dialog',
  templateUrl: 'hpe-order-details-dialog.component.html',
  styleUrls: ['hpe-order-details-dialog.component.scss'],
  providers: [HpeOrderDetailsGridDefinition],
})
export class HpeOrderDetailsDialogComponent implements OnInit, DialogInput<HpeOrderDetailsDialogConfig> {
  input: HpeOrderDetailsDialogConfig;
  details: HpeCcOrderDetails;

  constructor(public gridDefinition: HpeOrderDetailsGridDefinition,
              @Inject(MAT_DIALOG_DATA) public dialogData: any) {

  }

  get hpName(): string {
    return this.input.hpName;
  }

  get hpCode(): string {
    return this.input.hpCode;
  }

  ngOnInit(): void {
    this.details = getDialogInitData(this.dialogData);
  }
}

export const hpeOrderDetailsDialogRoute = createDialogRoute({
  component: HpeOrderDetailsDialogComponent,
  init: {
    service: HousePlanEstimateDetailsBusinessService,
    selector: 'initOrderDetailsDialog',
  },
});
